var ELEMENT_LABELS_MAP = {};
export function getElementLabels(type) {
    return ELEMENT_LABELS_MAP[type.toLowerCase()];
}
export function registerElementLabels(type, ctor) {
    if (getElementLabels(type)) {
        throw new Error("ElementLabels type '" + type + "' existed.");
    }
    ELEMENT_LABELS_MAP[type.toLowerCase()] = ctor;
}
//# sourceMappingURL=factory.js.map